<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!--        <vuexy-logo />-->
        <h2 class="brand-text text-primary ml-1">
          STM
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            {{ $t('Welcome to stm') }} 👋
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Please sign-in to your account and start the adventure') }}
          </b-card-text>

          <b-alert v-if="!loginState" variant="danger" show>
            <h4 class="alert-heading">
              {{ $t('error') }}

            </h4>
            <div class="alert-body">
              <!-- <span>{{ $t(errorMsg.message) }}</span> -->
              <br />
              <span>{{ $t(errorMsg.errors.email[0]) }}</span>
            </div>
          </b-alert>


          <!-- form -->
          <b-form class="auth-login-form mt-2" @submit.prevent="submit">
            <!-- email -->
            <b-form-group :label="$t('Email')" label-for="login-email">
              <b-form-input id="login-email" v-model="form.email" :state="null" name="login-email" placeholder="" />
              <!--                <small v-if="errorMsg?.errors?.email" class="text-danger">{{ $t(errorMsg.errors?.email[0]) }}</small>-->
            </b-form-group>

            <!-- forgot password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">{{ $t('Password') }}</label>
              </div>
              <b-input-group class="input-group-merge" :class="null">
                <b-form-input id="login-password" v-model="form.password" :state="null" class="form-control-merge"
                  :type="passwordFieldType" name="login-password" placeholder="Password" />
                <b-input-group-append is-text>
                  <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility" />
                </b-input-group-append>
              </b-input-group>
              <!--                <small v-if="f.errors.has('password')" class="text-danger">{{ $t(f.errors.get('password')) }}</small>-->
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1">
                {{ $t('Remember Me') }}
              </b-form-checkbox>
            </b-form-group>

            <!-- submit buttons -->
            <b-button type="submit" variant="primary" :disabled="loginBusy" block>
              <b-spinner v-if="loginBusy" small type="grow" />

              {{ $t('Sign in') }}
            </b-button>

          </b-form>

        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BSpinner,
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import Form from '@/libs/vForm'
import router from '@/router'
import { onUnmounted, ref } from '@vue/composition-api'
import api from '@/libs/axios'
import cookie from '@/api/Csrf'
import SocketClient from '@/services/websocket'
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    BSpinner
  },
  mixins: [togglePasswordVisibility],

  setup(props, { root }) {
    const { skin } = useAppConfig()

    const loginBusy = ref(false)
    const loginState = ref(true)
    const errorMsg = ref('')
    const status = ref('')
    const sideImg = require('@/assets/images/pages/login-v2.svg')

    const form = ref({
      email: '',
      password: '',
    })

    
    const applyUserSettings = (root) => {
      let lang = 'ar';
      let skinColor = 'light'
      if (store.state.auth.userData.settings.lang !== undefined) { lang = store.state.auth.userData.settings.lang; }
      if (store.state.auth.userData.settings.skin != undefined) { skinColor = store.state.auth.userData.settings.skin }
      skin.value = skinColor
      root.$i18n.locale = lang;
      document.getElementsByTagName('html')[0].dir = lang == 'ar' ? 'rtl' : 'ltr';

    }
    const submit = () => {

      loginBusy.value = true
      cookie.deleteAllCookies()
      cookie.getCookie().then((res) => {
        api.post('login', form.value).then((response) => {

          store.dispatch('auth/get_me').then(() => {
            loginBusy.value = false

            SocketClient.connect()

            //skin dir local here
            applyUserSettings(root);

            router.go(0)
          
          })

        }).catch(error => {

          if (error.response.status === 422)
            errorMsg.value = error.response.data

          loginState.value = false

        }).finally(_ => {
          loginBusy.value = false;
        });

      }).catch(e => console.log(e))


      // axios.post('login', form.value).then(result => {
      //   store.dispatch('auth/attempt', result.data.access_token).then(() => {
      //     loginBusy.value = false
      //     router.push({ name: 'dashboard' })
      //   })
      // }).catch(error => {
      //   loginBusy.value = false
      //   loginState.value = false
      //   errorMsg.value = error.response.data.error
      // });



    }

    return {
      submit,
      form, loginBusy,
      loginState, errorMsg, status,
      sideImg
    }

  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';
</style>
